import { createApiSlice } from "@common";
import { CRUD_EMPLOYEE_CATEGORY } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeCategory",
    method: "post",
    url: CRUD_EMPLOYEE_CATEGORY,
    stateKey: "message"
  },
  {
    name: "getEmployeeCategory",
    method: "get",
    url: CRUD_EMPLOYEE_CATEGORY,
    stateKey: "data"
  },
  {
    name: "updateEmployeeCategory",
    method: "put",
    url: CRUD_EMPLOYEE_CATEGORY,
    stateKey: "message"
  },
  {
    name: "deleteEmployeeCategory",
    method: "delete",
    url: CRUD_EMPLOYEE_CATEGORY,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } =
  createApiSlice("employeeCategory", apiConfig, customReducers);
const employeeCategorySlice = slice;

export default employeeCategorySlice.reducer;

export const {
  addEmployeeCategory,
  getEmployeeCategory,
  updateEmployeeCategory,
  deleteEmployeeCategory
} = thunks;
export const {
  rowSelect
} = actions;
